import apiClient from './client';

import type {
  GenerationReferenceDraft,
  GenerationReferenceItem,
  GenerationReferenceRoleValue,
  GenerationResourceTypeValue,
  GenerationTargetKey,
} from '@/types/generation-reference';

function serializeTargetQuery(target: GenerationTargetKey) {
  return {
    targetType: target.targetType,
    targetId: target.targetId,
    tagId: target.tagId ?? undefined,
    planId: target.planId ?? undefined,
    mediaType: target.mediaType,
  };
}

export const generationReferenceDraftsApi = {
  get(target: GenerationTargetKey): Promise<GenerationReferenceDraft> {
    return apiClient.get(`/projects/${target.projectId}/generation-reference-drafts`, {
      params: serializeTargetQuery(target),
    });
  },

  addEdge(params: {
    target: GenerationTargetKey;
    reference: GenerationReferenceItem;
  }): Promise<GenerationReferenceDraft> {
    return apiClient.post(
      `/projects/${params.target.projectId}/generation-reference-drafts/edges`,
      {
        target: params.target,
        reference: params.reference,
      }
    );
  },

  removeEdge(params: {
    target: GenerationTargetKey;
    resourceType: GenerationResourceTypeValue;
    resourceId: string;
    role: GenerationReferenceRoleValue;
  }): Promise<GenerationReferenceDraft> {
    return apiClient.delete(
      `/projects/${params.target.projectId}/generation-reference-drafts/edges`,
      {
        data: {
          target: params.target,
          resourceType: params.resourceType,
          resourceId: params.resourceId,
          role: params.role,
        },
      }
    );
  },
};
